import { PROD_URL, DEV_URL } from './constants'

export const truncate = string =>
  string.length > 120 ? `${string.substr(0, 120).trim()}...` : string

export const getBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return `${DEV_URL}/`
  }
  return `${PROD_URL}/`
}
